export default __webpack_public_path__ + "static/media/4.8285b17a.JPG";